import base_en from './en.json'
import base_fr from './fr.json'
import common_en from './common_en.json'
import common_fr from './common_fr.json'
import errorPage_en from './error-page_en.json'
import errorPage_fr from './error-page_fr.json'
import loadingPage_en from './loading-page_en.json'
import loadingPage_fr from './loading-page_fr.json'
import contactInfo_en from './contact-info_en.json'
import contactInfo_fr from './contact-info_fr.json'
import analytics_en from './analytics_en.json'
import myclaims_en from './myclaim_en.json'
import myclaims_fr from './myclaim_fr.json'
import cta_en from './cta_en.json'
import cta_fr from './cta_fr.json'
import forms_en from './forms_en.json'
import forms_fr from './forms_fr.json'
import quote_en from './quote_en.json'
import quote_fr from './quote_fr.json'
import intercept_en from './intercept_en.json'
import intercept_fr from './intercept_fr.json'
import messageAnimation_en from './message-animation_en.json'
import messageAnimation_fr from './message-animation_fr.json'
import submitClaim_en from './submitClaim_en.json'
import submitClaim_fr from './submitClaim_fr.json'
import datepicker_en from './datepicker_en.json'
import datepicker_fr from './datepicker_fr.json'
import overviewWidget_en from './overview-widget_en.json'
import insuranceToggle_en from './insurance-toggle_en.json'
import changeProduct_en from './change-product_en.json'
import rxtable_en from './rxtable_en.json'
import rxtable_fr from './rxtable_fr.json'
import rxhelpGuide_en from './rxhelp-guide_en.json'
import rxhelpGuide_fr from './rxhelp-guide_fr.json'

const base_resources = {
  en: {
    ...base_en,
    ...common_en,
    ...errorPage_en,
    ...loadingPage_en,
    ...contactInfo_en,
    ...cta_en,
    ...forms_en,
    ...myclaims_en,
    ...analytics_en,
    ...quote_en,
    ...intercept_en,
    ...messageAnimation_en,
    ...submitClaim_en,
    ...datepicker_en,
    ...overviewWidget_en,
    ...insuranceToggle_en,
    ...changeProduct_en,
    ...rxtable_en,
    ...rxhelpGuide_en,
  },
  fr: {
    ...base_fr,
    ...common_fr,
    ...errorPage_fr,
    ...loadingPage_fr,
    ...contactInfo_fr,
    ...cta_fr,
    ...forms_fr,
    ...myclaims_fr,
    ...analytics_en,
    ...quote_fr,
    ...intercept_fr,
    ...messageAnimation_fr,
    ...submitClaim_fr,
    ...datepicker_fr,
    ...rxtable_fr,
    ...rxhelpGuide_fr,
  },
}

export default base_resources
